import { Navigate, useLocation } from "react-router-dom";
import { useAuth, UserRole } from "@/contexts/AuthContext";
import GlobalLoader from "@/components/GlobalLoader";

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles: UserRole[];
  redirectTo?: string;
}

export default function ProtectedRoute({ children, allowedRoles, redirectTo = "/" }: ProtectedRouteProps) {
  let authContext: ReturnType<typeof useAuth> | null = null;
  try {
    authContext = useAuth();
  } catch {
    // During HMR, context may be temporarily unavailable
    return <GlobalLoader />;
  }

  const { user, isAuthenticated, isLoading } = authContext;
  const location = useLocation();

  if (isLoading) {
    return <GlobalLoader />;
  }

  if (!isAuthenticated || !user) {
    return <Navigate to={redirectTo} replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  // Redirect therapists to onboarding if not completed (except if already on onboarding page)
  if (
    user.role === "therapist" &&
    user.onboardingCompleted === false &&
    location.pathname !== "/terapeuta/onboarding"
  ) {
    return <Navigate to="/terapeuta/onboarding" replace />;
  }

  return <>{children}</>;
}
